import { BaseModel } from './BaseModel';
import { Server } from './Server';

export interface MapRotation {
    id: string;
    sequence: number;
    size: number | null;
    seed: string | null;
    randomSeed: boolean;
    randomLevel: boolean;
    customUrl: string | null;
    lastUsedAt: string | null;
}

export interface FileDeletion {
    id: string;
    path: string;
}

export class WipeSchedule extends BaseModel {
    public id = -1;
    public serverId = '';
    public name = '';
    public description = '';
    public wipeBlueprints = false;
    public nextRunAt = '';
    public repeatAnchorAt: string | null = null;
    public lastRunAt = '';
    public isProcessing = false;
    public isActive = false;
    public isRepeating = false;
    public repeatMode: 'cron' | 'biweekly' | 'force_wipe' = 'cron';
    public repeatDays: number[] = [];

    // Individual cron fields from the backend
    public cronMinute = '';
    public cronHour = '';
    public cronDayOfMonth = '';
    public cronMonth = '';
    public cronDayOfWeek = '';
    public timezone = 'UTC';
    public formattedCron = '';

    // Compatibility getter to provide a cron object for the UI
    get cron() {
        return {
            minute: this.cronMinute || '0',
            hour: this.cronHour || '0',
            day_of_month: this.cronDayOfMonth || '*',
            day_of_week: this.cronDayOfWeek || '*',
        };
    }

    public createdAt = '';
    public updatedAt = '';

    get server(): Server {
        return this.getRelationship('server');
    }

    get mapRotations(): MapRotation[] {
        return this.getRelationship('map_rotations') || [];
    }

    get fileDeletions(): FileDeletion[] {
        return this.getRelationship('file_deletions') || [];
    }

    getRouteName() {
        return 'wipe_schedule';
    }

    getRouteID() {
        return this.id.toString();
    }
}
